/**
 * Created by Nikolai Gorte
 * User: n.gorte on 30.08.2016
 * Copyright: xdot GmbH 2016
 */
import React from 'external/react';
import PropTypes from 'external/prop-types';
import '../css/_spinner.scss';
import { Alert, Button } from 'external/react-bootstrap';
import translation from '../utils/translation';

import '../css/_flags.scss';

// eslint-disable-next-line react/prop-types
const Error = ({ _error, sendErrorMail }) => {
    return (<Alert variant="danger">
        <h3>Es ist ein Fehler aufgetreten.</h3>

        <h4>Fehlernachrichten: </h4>
        {_error.map((e, i) => (<p key={i}>{e.error && e.error.message || e}</p>))}

        <h4>Fehlertyp:</h4>
        <p>{}</p>
        {_error.map((e, i) => (<p key={i}>{translation.transException(e.exception)}</p>))}

        {sendErrorMail &&
        <Button variant="warning" onClick={() => sendErrorMail(_error[ 0 ])}>Fehler per E-Mail senden</Button>}
    </Alert>);
};

const Loader = () => {
    return (<div className="spinner-container">
        <div className="sk-circle spinner">
            <div className="sk-circle1 sk-child"/>
            <div className="sk-circle2 sk-child"/>
            <div className="sk-circle3 sk-child"/>
            <div className="sk-circle4 sk-child"/>
            <div className="sk-circle5 sk-child"/>
            <div className="sk-circle6 sk-child"/>
            <div className="sk-circle7 sk-child"/>
            <div className="sk-circle8 sk-child"/>
            <div className="sk-circle9 sk-child"/>
            <div className="sk-circle10 sk-child"/>
            <div className="sk-circle11 sk-child"/>
            <div className="sk-circle12 sk-child"/>
        </div>
    </div>);
};

function sendErrorMail(_error) {
    window.location = 'mailto:fliwas@komm.one?subject=FLIWAS Benutzer-Fehlermeldung&body=Automatisierte%20Fehlermeldung%0D%0A%0D%0AException:%20' + translation.transException(_error.exception) + '%0D%0A%0D%0AMessage:%20' + (_error.error && _error.error.message) + '%0D%0A%0D%0A%0D%0A%0D%0ABenutzerhinweis:%20Bitte%20hier%20eine%20Beschreibung%20einfügen.';
}

const defaultDataPropNames = [ 'item', 'list', 'dataItem', 'dataList' ];

const flagHOC = (WrappedComponent, dataPropNames) => {

    const propNames = dataPropNames || defaultDataPropNames;
    if (!dataPropNames) {
        console.warn('Use explicit binding!');
    }

    const FlagHOC = (props) => {


        const items = propNames.map(propName => props[ propName ]).filter(i => !!i);

        let _loading = false, _error = [];

        items.forEach(item => {
            _loading = _loading || item._loading;
            if (item._error) {
                _error.push(item._error);
            }
        });

        if (items.length > 1) {
            console.warn('DO not use FlagHOC with multiple data items in props', items);
        }

        return (
            <React.Fragment>

                {
                    items.length > 0 ?
                        (_error.length > 0 ?
                                <Error _error={_error} sendErrorMail={sendErrorMail}/>
                                :
                                <WrappedComponent {...props}/>
                        )
                        :
                        //(JSON.stringify(Object.keys(props))) //TODO should this really be displayed??
                        ''
                }

                {_loading && <Loader/>}

            </React.Fragment>
        );
    };

    FlagHOC.propTypes = {
        item: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array
        ]),
        list: PropTypes.object,
        dataItem: PropTypes.object,
        dataList: PropTypes.object
    };

    return FlagHOC;
};

export default flagHOC;

const FlagComponent = props => props.children;

const C = flagHOC(FlagComponent, [ 'item' ]);

export { C as FlagComponent };



// WEBPACK FOOTER //
// ./js/components/FlagHOC.jsx